class AccordionElement extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector(".accordion");
    this.panel = this.querySelector(".panel");
    this.accordion.addEventListener("click", this.toggleAccordion.bind(this));
    this.accordion.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        this.accordion.click();
      }
    });
    this.anchors = this.querySelectorAll("a");
    this.anchors.forEach((anchor) => {
      anchor.addEventListener("click", (event) => {
        event.stopPropagation(); // Prevent the accordion from closing
      });
    });
  }

  toggleAccordion() {
    if (this.accordion) {
      if (this.accordion.classList.contains("active")) {
        const productAccordions = document.querySelector("product-accordions");
        if (productAccordions) {
          productAccordions.closeAccordions();
        }

        this.panel.style.maxHeight = "0";
        this.panel.classList.toggle("open");

        const headerHeight = document.querySelector("header").offsetHeight;
        const scrollOptions = {
          behavior: "smooth",
          top: this.accordion.offsetTop - parseInt(headerHeight),
        };

        if (this.classList.contains("child")) {
          const parentPanel = this.closest(".panel");
          const parentPanelHeight = parentPanel.scrollHeight;
          parentPanel.style.maxHeight = parentPanelHeight + "px";
        }
        this.accordion.classList.remove("active");
        if (!this.panel.dataset.panel) return;
        document.documentElement.classList.toggle(this.panel.dataset.panel);
      } else {
        this.panel.classList.toggle("open");
        if (this.classList.contains("child")) {
          const parentPanel = this.closest(".panel");
          const parentAccordion = parentPanel.previousElementSibling;
          const parentAccordionPanel = parentAccordion.closest(".panel");
          const parentPanelHeight = parentPanel.scrollHeight;
          const childPanelHeight = this.panel.scrollHeight;
          const combinedHeight = parentPanelHeight + childPanelHeight;
          parentPanel.style.maxHeight = combinedHeight + "px";
          this.panel.style.maxHeight = combinedHeight + "px";
          if (parentAccordionPanel) {
            parentAccordionPanel.style.maxHeight = combinedHeight + "px";
          }
        } else {
          this.panel.style.maxHeight = this.panel.scrollHeight + "px";
        }
        this.accordion.classList.add("active");
        if (!this.panel.dataset.panel) return;
        document.documentElement.classList.toggle(this.panel.dataset.panel);
      }
    }
  }
}

customElements.define("accordion-element", AccordionElement);
